<template>
  <div class="messageTemplateList">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="item.label"
        :name="item.value"
        v-for="(item, index) in activeList"
        :key="index"
      >
        <component
          :is="item.componentId"
          v-if="activeName == item.value"
        ></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TemplateList from './templateList.vue'
import CategorySetList from './categorySetList.vue'
export default {
  name: 'MessageTemplateList',
  components: { TemplateList, CategorySetList },
  data() {
    return {
      activeName: '1',
      activeList: [
        { label: '消息模版', value: '1', componentId: 'TemplateList' },
        { label: '类别设置', value: '2', componentId: 'categorySetList' }
      ]
    }
  },
  methods: {
    handleClick() {}
  }
}
</script>

<style lang="scss" scoped>
.messageTemplateList {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  /deep/.el-tabs__content {
    height: calc(100% - 41px);
    padding: 10px 20px 20px;
  }

  /deep/.el-dialog__body {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
}
</style>
